import React, { useEffect, useState, useContext } from "react";
import "./Experience.css";
import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Experience = () => {
  const { currentLang } = useContext(LanguageContext);
  const [experience, setExperience] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExperience = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${API_BASE}/api/experiencesection?lang=${currentLang}`
        );
        setExperience(res.data);
      } catch (err) {
        console.error("Error fetching experience data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchExperience();
  }, [currentLang]);

  if (loading) {
    return <div className="experience-loading">Loading...</div>;
  }

  if (!experience) {
    return <div className="experience-error">No experience data found.</div>;
  }

  const layoutStyle = {
    backgroundImage: experience.imageUrl
      ? `url(${
          experience.imageUrl.startsWith("http")
            ? experience.imageUrl
            : `${API_BASE}${experience.imageUrl}`
        })`
      : "none",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center",
    width: "100%",
    aspectRatio: "16 / 9",
  };

  return (
    <div className="experience">
      <div className="experience-layout" style={layoutStyle}>
        <div className="experience-header">
          <h1>{experience.title}</h1>
        </div>
      </div>

      <div className="experience-down">
        {experience.stats && experience.stats.length > 0 ? (
          experience.stats.map((item, index) => (
            <div className="ed-con" key={index}>
              <div className="divider"></div>
              <h1 className="ed-h1">{item.value}</h1>
              <p>{item.label}</p>
            </div>
          ))
        ) : (
          <p>No statistics available.</p>
        )}
      </div>
    </div>
  );
};

export default Experience;
